var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "message-form"
  }, [_c('BranchPc', {
    attrs: {
      "payload": _vm.forwardPayload
    },
    on: {
      "input-click": _vm.handleContentListItemClick
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }